import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const getTxnAuth = createAsyncThunk(
  "getTxnAuth",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transaction_auth_matrix/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }
      const errorMessage =
        response.data?.message ||
        response.data?.error ||
        "Something went wrong";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    } catch (error) {
      CommonToast({
        text: error.message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error.message);
    }
  },
);
export const testPredictedApproval = createAsyncThunk(
  "testPredictedApproval",
  async (
    { entity_id, txnType, amount, existing_approvals_grade_count },
    { rejectWithValue },
  ) => {
    try {
      const body = {
        entity_id,
        type_of_transaction: txnType,
        amount,
        existing_approvals_grade_count,
      };

      const response = await axiosInstance.post(
        `${baseUrl}/transaction_auth_matrix/test_predicted_approval`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }

      const errorMessage =
        response.data?.message ||
        response.data?.error ||
        "Something went wrong";

      return rejectWithValue(errorMessage);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const testAuthMatrix = createAsyncThunk(
  "testAuthMatrix",
  async (
    { entity_id, txnType, user_id, user_grade, amount, existing_approvals },
    { rejectWithValue },
  ) => {
    try {
      const body = {
        entity_id,
        type_of_transaction: txnType,
        user_id,
        user_grade,
        amount,
        existing_approvals,
      };

      const response = await axiosInstance.post(
        `${baseUrl}/transaction_auth_matrix/test_matrix`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return rejectWithValue(undefined);
      }

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }

      const errorMessage =
        response.data?.message ||
        response.data?.error ||
        "Something went wrong";

      return rejectWithValue(errorMessage);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const TestAuthMatrix = createSlice({
  name: "TestAuthMatrix",
  initialState: {
    getTxnAuthLoading: false,
    getTxnAuthData: null,
    getTxnAuthError: false,

    testPredictedApprovalLoading: false,
    testPredictedApprovalData: null,
    testPredictedApprovalError: false,

    testAuthMatrixLoading: false,
    testAuthMatrixData: null,
    testAuthMatrixError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getTxnAuth.pending, (state, action) => {
      state.getTxnAuthLoading = true;
    });
    builder.addCase(getTxnAuth.fulfilled, (state, action) => {
      state.getTxnAuthLoading = false;
      state.getTxnAuthData = action.payload;
    });
    builder.addCase(getTxnAuth.rejected, (state, action) => {
      state.getTxnAuthLoading = false;
      state.getTxnAuthError = true;
    });

    builder.addCase(testPredictedApproval.pending, (state, action) => {
      state.testPredictedApprovalLoading = true;
    });
    builder.addCase(testPredictedApproval.fulfilled, (state, action) => {
      state.testPredictedApprovalLoading = false;
      state.testPredictedApprovalData = action.payload;
    });
    builder.addCase(testPredictedApproval.rejected, (state, action) => {
      state.testPredictedApprovalLoading = false;
      state.testPredictedApprovalError = true;
    });

    builder.addCase(testAuthMatrix.pending, (state, action) => {
      state.testAuthMatrixLoading = true;
    });
    builder.addCase(testAuthMatrix.fulfilled, (state, action) => {
      state.testAuthMatrixLoading = false;
      state.testAuthMatrixData = action.payload;
    });
    builder.addCase(testAuthMatrix.rejected, (state, action) => {
      state.testAuthMatrixLoading = false;
      state.testAuthMatrixError = true;
    });
  },
});

export default TestAuthMatrix.reducer;
